import React from 'react';

/**
 * SuggestionButton component for displaying individual suggestion buttons.
 *
 * @param {Object} props - Component props
 * @param {string} props.suggestion - The suggestion text to display
 * @param {Function} props.onClick - Callback when suggestion is clicked
 * @param {number} props.index - Index of the suggestion for styling/animation
 * @param {boolean} props.disabled - Whether the button is disabled
 * @returns {JSX.Element} Suggestion button component
 */
const SuggestionButton = ({ suggestion, onClick, index = 0, disabled = false }) => {
    const handleClick = (e) => {
        e.preventDefault();
        if (!disabled && onClick) {
            onClick(suggestion);
        }
    };

    const animationDelay = `${index * 100}ms`; // Stagger animation

    return (
        <button
            className={`talkflow-suggestion-button ${disabled ? 'disabled' : ''}`}
            onClick={handleClick}
            disabled={disabled}
            style={{ animationDelay }}
            title={suggestion}
        >
            <span className="talkflow-suggestion-text">{suggestion}</span>
            <span className="talkflow-suggestion-icon">💬</span>
        </button>
    );
};

export default SuggestionButton; 